import { NeoContainer } from './NeoContainer';
var AppService = /** @class */ (function () {
    /**
     * Creates a new App Service
     * @param container The types container (Optional)
     */
    function AppService(container) {
        if (container === void 0) { container = new NeoContainer({ skipBaseClassChecks: true }); }
        this.container = container;
        this.modules = [];
    }
    AppService.prototype.get = function (symbolOrSid) {
        return this.container.get(symbolOrSid);
    };
    /**
     * Register a module
     * @param module The module
     */
    AppService.prototype.registerModule = function (module) {
        this.modules.push(module);
        module.typesRegistrationHandler(this.container);
    };
    return AppService;
}());
export { AppService };
